import React from 'react';
import './home.css';
import './delete_account.css';

import FadeInSection from '../animation/fadein_onscroll';
import { useTranslation } from 'react-i18next';

document.querySelectorAll('a[data-scroll]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

function DeleteAccount() {
  const { t } = useTranslation();
  return (
    <div className="subpage-padding" id='start'>
      <FadeInSection>
        <h1>{t('deleteAccount.title')}</h1>
      </FadeInSection>
      <div className="max-width">
        <FadeInSection>
          <p>
            {t('deleteAccount.description')}
          </p>
          <ol className="ol">
            <li>{t('deleteAccount.step1')}</li>
            <li>{t('deleteAccount.step2')}</li>
            <li>{t('deleteAccount.step3')}</li>
          </ol>
          <br />
          <br />
          <a 
            href="mailto:contact@qualityfoodcontrol.com?subject=Jag%20vill%20ta%20bort%20mitt%20QFC-konto&body=Hej,%20jag%20vill%20ta%20bort%20mitt%20QFC-konto.%20%0A%0A%20{Ange%20din%20e-postadress%20här}"
            className="button-primary large"
          >
            {t('deleteAccount.ctaDelete')}
          </a>
        </FadeInSection>
      </div>
    </div>
  );
}

export default DeleteAccount;